import { React } from "react";
import { Outlet } from 'react-router-dom'
import M_Footer from './M_Footer'
import M_Header from './M_Header'

const M_Layout = () => {
    if(String(localStorage.getItem("company_nm")) === 'MES'){
        document.title = "MES";
    }else{
        document.title = String(localStorage.getItem("company_nm")) + " MES";
    }
    return (
        <div className="m-layout" style={ { maxWidth: '430px', height: '100vh', marginLeft: 'auto', marginRight: 'auto', padding: '0px', backgroundColor:'#f2f2f2' } }>
            <M_Header />
            {
            /*
            <M_Footer />
            */
            }
        </div>
    )
}

export default M_Layout